import Link from '@components/primitives/Link'
import Routes from '@lib/routes'
import DynamicRoutes from '@lib/routes/DynamicRoutes'
import absoluteUrl from '@lib/routes/helpers/absoluteUrl'

export const TrialTitleWithConditionHighlight = ({
  slug,
  trialTitle,
}: {
  slug?: string
  trialTitle: string
}) => {
  // FIXME: IMO this is feels fragile however its been the generally accepted pattern
  const [treatment, condition] = trialTitle.split(' for ')
  const hasTreatmentAndCondition = Boolean(treatment) && Boolean(condition)

  if (hasTreatmentAndCondition) {
    return (
      <Link
        href={absoluteUrl(slug ? DynamicRoutes.trial(slug) : Routes.search)}
        newTab
      >
        <h4 className='line-clamp-3 w-fit text-lg font-bold leading-normal underline decoration-primary200 underline-offset-4 antialiased'>
          {treatment}
          <strong className='not-italic text-primary500'>
            {' '}
            for {condition}
          </strong>
        </h4>
      </Link>
    )
  }

  return (
    <Link
      href={absoluteUrl(slug ? DynamicRoutes.trial(slug) : Routes.search)}
      newTab
    >
      <h4
        className='line-clamp-3 w-fit text-lg font-bold leading-normal underline decoration-primary500 decoration-dotted underline-offset-4 antialiased'
        title={trialTitle}
      >
        {trialTitle}
      </h4>
    </Link>
  )
}
